import './core/credits.js';
import './core/general.js';
import './components/cookieconsent.js';
import './components/header.js';
import './components/formie.js';
import './components/contact-form.js';
import './components/quote-form.js';
import './components/quote-request.js';
import './components/situation-tabs.js';
import '@tailwindplus/elements';
import Alpine from 'alpinejs';
import sort from '@alpinejs/sort';
import persist from '@alpinejs/persist'
import 'lazysizes';
import Plyr from 'plyr';

// Components

// Global
window.Alpine = Alpine;
window.Plyr = Plyr;

// Inits
Alpine.plugin(sort);
Alpine.plugin(persist);
Alpine.start();


